// src/components/activity.js

import React, { useState, useEffect } from 'react';
import './Activity.css'; // Add your custom CSS here
import Img from '../../assets/divider2.png';
import { storage } from '../../firebase';
import { ref, listAll, getDownloadURL } from 'firebase/storage';

const Activity = () => {
  const [photos, setPhotos] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [loading, setLoading] = useState(true); // State for loading indicator

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const storageRef = ref(storage, 'ActivityImages'); // Replace 'activity' with your Firebase Storage folder
        const result = await listAll(storageRef);
        const urlPromises = result.items.map((imageRef) => getDownloadURL(imageRef));

        const urls = await Promise.all(urlPromises);
        const images = urls.map((url, index) => ({
          src: url,
          alt: `Image ${index + 1}`,
        }));

        setPhotos(images);
        setLoading(false); // Set loading state to false once images are fetched
      } catch (error) {
        console.error('Error fetching images from Firebase Storage:', error);
        setLoading(false); // Set loading state to false on error as well
      }
    };

    fetchImages();
  }, []);

  const openLightbox = (src) => {
    setSelectedImage(src);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  return (
    <div className='activity-section'>
      <div className='donation-title' style={{ textAlign: 'center' }}>
        <h4>ACTIVITY IN FRAME</h4>
      
        <div class="title-underline-donation"></div>

       <p> HIGHLIGHTING KEY INITIATIVES AND ENGAGEMENTS.</p>
      </div>

      {loading ? (
        <div className="loading-placeholder">Loading...</div>
      ) : (
        <div className="activity">
          {photos.map((photo, index) => (
            <div className="activity-item" key={index} onClick={() => openLightbox(photo.src)}>
              <img src={photo.src} alt={photo.alt} />
            </div>
          ))}
        </div>
      )}

      {selectedImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <div className="lightbox-content">
            <img src={selectedImage} alt="Enlarged" />
          </div>
        </div>
      )}
    </div>
  );
};

export default Activity;
